export const EVENT_MODAL_SHOW = 'fabric-modal-show'
export const EVENT_MODAL_HIDE = 'fabric-modal-hide'
